import { types, actions } from './requests'
export const CREATEWORKORDER_TYPES = {
    ...types('CREATEWORKORDER'),
}
export const CREATEWORKORDER_ACTIONS = {
    ...actions('CREATEWORKORDER'),
}